<template>
  <div id="general-layout" class="flex flex-col min-h-screen text-[#1a233f]">
    <HeaderSection />
    <main class="flex-1">
      <router-view />
      <Toast />
      <ConfirmDialog />
    </main>
    <FooterSection />
    <CookieBanner />
  </div>
</template>

<script setup>
import HeaderSection from '@/components/general/HeaderSection.vue'
import FooterSection from '@/components/general/FooterSection.vue'
import CookieBanner from '@/components/general/CookieBanner.vue'
import { ConfirmDialog, Toast } from 'primevue'
import { useManufacturersStore } from '@/stores/general/manufacturersStore'
import { onMounted } from 'vue'
import { useDarkModeStore } from '@/stores/darkModeStore'

const darkModeStore = useDarkModeStore()
const { fetchManufacturers } = useManufacturersStore()
fetchManufacturers({ perPage: 100, 'filter[websiteVisible]': true })

onMounted(() => {
  darkModeStore.deactivate()
})
</script>

<style>
#general-layout,
.general-drawer {
  --p-select-focus-ring-shadow: 0 0 0 1px #2db9d6;
  --p-select-focus-border-color: #2db9d6;
  --p-select-hover-border-color: #d1d5db;
  --p-inputtext-focus-border-color: #2db9d6;
  --p-inputtext-focus-ring-shadow: 0 0 0 1px #2db9d6;
  --p-textarea-focus-border-color: #2db9d6;
  --p-textarea-focus-ring-shadow: 0 0 0 1px #2db9d6;
  --p-primary-color: #2db9d6;
  --p-primary-hover-color: #259cb5;
}
</style>
